module.exports = __webpack_public_path__ + "static/img/Charlie_Cameron_desktop.460e1fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Charlie_Cameron_desktop.jpg
// module id = rdnN
// module chunks = 0